import { Button, Text, Tooltip, makeStyles, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useMessageFeedback } from '../../../libs/hooks/useMessageFeedback';
import { IChatMessage, UserFeedback } from '../../../libs/models/ChatMessage';
import { ThumbDislike16, ThumbLike16 } from '../../shared/BundledIcons';
import { ThumbDislike16Filled, ThumbLike16Filled } from '@fluentui/react-icons';

const useClasses = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
    },
    feedbackButton: {
        color: tokens.colorNeutralForeground2,
        ':hover': {
            color: tokens.colorNeutralForeground2,
        },
        ':active': {
            color: tokens.colorNeutralForeground2,
        },
    },
});

interface IUserFeedbackProps {
    message: IChatMessage;
}

export const UserFeedbackActions: React.FC<IUserFeedbackProps> = ({ message }) => {
    const classes = useClasses();
    const { t } = useTranslation();

    // Thumbs flow: tag the rating as 'thumbs' and also open the optional free-text comment dialog.
    // Keeps the historical conflict-only alerting (other errors stay silent) by leaving
    // alertOnAnyError off.
    const recordFeedback = useMessageFeedback({ source: 'thumbs', openCommentDialog: true });
    const onUserFeedbackProvided = (positive: boolean) => {
        recordFeedback(message, positive);
    };

    const likeIcon = message.userFeedback == UserFeedback.Positive ? <ThumbLike16Filled /> : <ThumbLike16 />;
    const dislikeIcon = message.userFeedback == UserFeedback.Negative ? <ThumbDislike16Filled /> : <ThumbDislike16 />;

    return (
        <div className={classes.root}>
            <Text color="gray" size={200}></Text>
            <Tooltip content={t('userFeedbackActions.likeDescription')} relationship="label">
                <Button
                    icon={likeIcon}
                    appearance="transparent"
                    aria-label="Edit"
                    className={classes.feedbackButton}
                    onClick={() => {
                        onUserFeedbackProvided(true);
                    }}
                />
            </Tooltip>
            <Tooltip content={t('userFeedbackActions.dislikeDescription')} relationship="label">
                <Button
                    icon={dislikeIcon}
                    appearance="transparent"
                    aria-label="Edit"
                    className={classes.feedbackButton}
                    onClick={() => {
                        onUserFeedbackProvided(false);
                    }}
                />
            </Tooltip>
        </div>
    );
};
